export default function FormTitle({className = "", ...props}){

    return(
        <h2 className={`pb-3 pt-3 mb-3 border-bottom text-center ${className}`}>{props.children}</h2>
    );
}